import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const trackPageView = async (page) => {
  try {
    await axios.post(`${API}/analytics`, {
      event_type: "page_view",
      page: page,
      metadata: {
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      },
    });
  } catch (e) {
    console.error("Analytics tracking failed:", e);
  }
};

export const trackCTAClick = async (ctaName, page) => {
  try {
    await axios.post(`${API}/analytics`, {
      event_type: "cta_click",
      page: page,
      metadata: {
        cta_name: ctaName,
        timestamp: new Date().toISOString(),
      },
    });
  } catch (e) {
    console.error("Analytics tracking failed:", e);
  }
};

export const trackFormSubmit = async (formType, page) => {
  try {
    await axios.post(`${API}/analytics`, {
      event_type: "form_submit",
      page: page,
      metadata: {
        form_type: formType,
        timestamp: new Date().toISOString(),
      },
    });
  } catch (e) {
    console.error("Analytics tracking failed:", e);
  }
};
